import { useState, useCallback } from 'react';

export const useBasicFilters = (initialFilters) => {
    const [filters, setFilters] = useState(initialFilters);

    const addFilter = useCallback((field, op, value) => {
        setFilters((prev) => [...prev, { field, op, value }]);
    }, []);

    const updateFilter = useCallback((field, op, value) => {
        setFilters((prev) =>
            prev.map((f) =>
                f.field === field && f.op === op ? { ...f, value } : f
            )
        );
    }, []);

    const updateWithOpChange = useCallback((field, op, value) => {
        setFilters((prev) =>
            prev.map((f) => (f.field === field ? { ...f, op, value } : f))
        );
    }, []);

    const removeFilter = useCallback((field, op) => {
        setFilters((prev) =>
            prev.filter((f) => !(f.field === field && f.op === op))
        );
    }, []);

    const replaceFilters = useCallback((newFilters) => {
        setFilters(newFilters);
    }, []);

    return {
        filters,
        addFilter,
        updateFilter,
        updateWithOpChange,
        removeFilter,
        replaceFilters
    };
};
